import translations from './translations'

translations.add('pt', {
    iAgreeWith: 'Eu concordo com',
    termsAndConditions: 'termos e condições',
    pay: 'PAGAR'
})
